import React, { useEffect, useState } from 'react'
import { View, Text, Image, Dimensions, ImageBackground, Platform } from 'react-native'
import styles from './RankingStyles'
import theme from '../../../theme'
import { avatarPlaceholder, placeholderGeneral } from '../customUtils/Constants'
import { FlatList, TouchableOpacity } from 'react-native-gesture-handler'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { RoundedTabs } from '../customUtils/LinealTabs'
import { RankingMainColor, RankingTheme } from '../../../themeConstants'
import { LinearGradient } from 'expo-linear-gradient'
import { request_get_ranking } from '../../services/ranking.services'
import { resetCache } from '../../utils/FetchServices'
import { Loader } from '../customUtils/Components/Loader'
import { getAuthToken } from '../../utils/functions.utils'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
const { width, height } = Dimensions.get('window')
const isWeb = Platform.OS === 'web'
export const RankingScreen = () => {
    const [loading, isLoading] = useState(true)
    let isFocused: boolean = true
    try {
        isFocused = useIsFocused()
    } catch (e) {
        if (Platform?.OS === 'web') {
            isFocused = true
        } else {
            throw e
        }
    }
    useEffect(() => {
        fetchData()
    }, [isFocused])

    async function fetchData() {
        try {
            const authToken = await getAuthToken()
            if (!authToken) return
            let data = await request_get_ranking({ authToken })
            if (!data || !data.single) throw new Error('No data received from ranking service')
            const rankingData = data.single.ranking || []
            const globalRankingData = data.single.ranking_global || []
            setData({ ranking: rankingData, globalRanking: globalRankingData, history: [] })
            resetCache()
        } catch (e) {
            console.log('Error fetching ranking data: ==>', e)
        } finally {
            isLoading(false)
        }
    }
    const [data, setData] = useState({ ranking: [], globalRanking: [], history: [] })
    const { ranking, globalRanking, history } = data
    if (loading) {
        return <Loader />
    }
    return (
        <View style={styles.container}>
            <RankingTabs ranking={ranking} globalRanking={globalRanking} history={history} />
        </View>
    )
}
export const RankingTabs = ({ ranking = [], globalRanking = [], history = [] }) => {
    const [selectedIndex, setSelectedIndex] = useState(null)

    const { languageFile } = getLanguage()

    const tabs = setTabs()
    function setTabs() {
        let tabs = []
        if (ranking.length > 0) {
            tabs.push({
                name: languageFile.mensual,
                index: 0,
            })
        }
        if (globalRanking.length > 0) {
            tabs.push({
                name: languageFile.acumulado,
                index: 1,
            })
        }
        return tabs
    }
    useEffect(() => {
        if (tabs.length === 0) {
            setSelectedIndex(-1)
        } else {
            let firstTabIndex = tabs[0].index
            setSelectedIndex(firstTabIndex)
        }
    }, [tabs.length])

    const viewMargin = !isWeb ? (tabs.length > 1 ? -15 : 0) : 0

    const findPodium = (data) => {
        let first_place = null
        let second_place = null
        let third_place = null
        if (!data || data.length === 0) return { first_place, second_place, third_place }
        first_place = data.find((item) => item.position == 1)
        second_place = data.find((item) => item.position == 2)
        third_place = data.find((item) => item.position == 3)
        return { first_place, second_place, third_place }
    }
    const isMobile = useIsMobile()
    return (
        <View
            style={{
                flex: 1,
                backgroundColor: 'white',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <View style={[styles.container, isWeb && { maxWidth: 1024, alignSelf: 'center', flex: undefined }]}>
                {tabs.length > 1 && (
                    <RoundedTabs
                        tabs={tabs}
                        selectedIndex={selectedIndex}
                        colorLGStart={RankingTheme.rankingGradient[0]}
                        colorLGEnd={RankingTheme.rankingGradient[1]}
                        colorSelected={RankingTheme.tabsSelectedColor}
                        colorUnselected={RankingTheme.tabsUnselectedColor}
                        onSelectedTab={(index) => {
                            console.log('SELECTED INDEX', index)
                            setSelectedIndex(index)
                        }}
                        containerStyle={{ marginHorizontal: 12 }}
                        textColorOn={RankingMainColor}
                        textColorOff={theme.colors.textPrimary}
                    />
                )}

                {(() => {
                    switch (selectedIndex) {
                        case 0:
                            const { first_place, second_place, third_place } = findPodium(ranking)
                            const filteredRanking = ranking.filter((i) => Number(i.position) > 3)
                            return (
                                <View style={[{ flex: 1, marginTop: 0, width: '100%', alignItems: 'center' }]}>
                                    <View style={[{ flex: 1, width: '100%' }, !isMobile && { maxWidth: 952 }]}>
                                        <RankingPodium
                                            first_place={setPodiumUser(first_place)}
                                            second_place={setPodiumUser(second_place)}
                                            third_place={setPodiumUser(third_place)}
                                        />
                                        <View style={{ height: 16 }} />
                                        <View style={{ flex: 1 }}>
                                            <FlatList
                                                style={{ backgroundColor: 'transparent' }}
                                                data={filteredRanking}
                                                keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                                                horizontal={false}
                                                showsHorizontalScrollIndicator={false}
                                                showsVerticalScrollIndicator={false}
                                                renderItem={({ item }) => <RankingItem item={item} />}
                                            />
                                        </View>
                                    </View>
                                </View>
                            )
                        case 1:
                            const {
                                first_place: globalFirstPlace,
                                second_place: globalSecondPlace,
                                third_place: globalThirdPlace,
                            } = findPodium(globalRanking)
                            const filteredGlobalRanking = globalRanking.filter((i) => Number(i.position) > 3)

                            return (
                                <View style={[{ flex: 1, marginTop: 0, width: '100%', alignItems: 'center' }]}>
                                    <View style={[{ flex: 1, width: '100%' }, !isMobile && { maxWidth: 952 }]}>
                                        <RankingPodium
                                            first_place={setPodiumUser(globalFirstPlace)}
                                            second_place={setPodiumUser(globalSecondPlace)}
                                            third_place={setPodiumUser(globalThirdPlace)}
                                        />
                                        <View style={{ height: 16 }} />
                                        <View style={{ flex: 1 }}>
                                            <FlatList
                                                style={{ backgroundColor: 'white' }}
                                                data={filteredGlobalRanking}
                                                keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                                                horizontal={false}
                                                showsHorizontalScrollIndicator={false}
                                                showsVerticalScrollIndicator={false}
                                                renderItem={({ item }) => <RankingItem item={item} />}
                                            />
                                        </View>
                                    </View>
                                </View>
                            )
                        default:
                            return (
                                <>
                                    {ranking.length === 0 && globalRanking.length === 0 && (
                                        <View style={{ flex: 1 }}>
                                            <RankingPodium
                                                first_place={setPodiumUser(null)}
                                                second_place={setPodiumUser(null)}
                                                third_place={setPodiumUser(null)}
                                            />
                                            <View style={{ height: 32 }} />
                                            <NoRankingModal />
                                        </View>
                                    )}
                                </>
                            )
                    }
                })()}
            </View>
        </View>
    )
}
const RankingItem = ({ item }) => {
    const { languageFile } = getLanguage()
    const [image, setImage] = useState(item.avatar ? item.avatar : avatarPlaceholder)
    const isMobile = useIsMobile()

    return (
        <View>
            <View style={[styles.triviaItem, { pointerEvents: 'none', paddingTop: 12, paddingBottom: 2 }]}>
                <Text style={[styles.triviaName, { marginEnd: 12, color: RankingTheme.rankingPositionTextColor, fontSize: 17, minWidth: 35 }]}>
                    {item.position + '°'}
                </Text>
                {item.avatar && (
                    <Image
                        style={styles.triviaImage}
                        source={{ uri: image }}
                        onError={() => {
                            setImage(avatarPlaceholder)
                        }}
                    />
                )}
                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', marginStart: 6 }}>
                    <Text
                        style={[
                            styles.triviaDescription,
                            { marginEnd: 12, color: RankingTheme.rankingUserTextColor },
                            item.current_user && { fontWeight: 'bold' },
                        ]}
                    >
                        {item.name + ' ' + (item.last_name || '')}
                    </Text>
                    {item.current_user && (
                        <Text style={{ fontWeight: '700', fontSize: 14, marginTop: 3, color: RankingTheme.podiumUserPointsTextcolor }}>
                            ¡Tu estás aquí!
                        </Text>
                    )}
                </View>
                {item.points && (
                    <View
                        style={{
                            minWidth: 100,
                            flexDirection: 'row',
                            borderWidth: 1,
                            borderColor: RankingTheme.rankingPointsBorderColor,
                            backgroundColor: 'white',
                            borderRadius: 12,
                            alignContent: 'center',
                            alignItems: 'center',
                            paddingHorizontal: 12,
                            paddingVertical: 7,
                            paddingTop: 5,
                            justifyContent: 'center',
                        }}
                    >
                        <Text style={styles.podium_user_points_text}>{item.points}</Text>
                        <Text style={styles.podium_user_points_Pts}> pts</Text>
                    </View>
                )}
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const HistoryItem = ({ points, activity, dateString }: { points: number; activity: string; dateString: string }) => {
    function parseFecha(dateString: string): { date: string; time: string } {
        const dateObj = new Date(dateString)
        const day = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const year = dateObj.getFullYear()
        const hours = String(dateObj.getHours()).padStart(2, '0')
        const minutes = String(dateObj.getMinutes()).padStart(2, '0')

        return {
            date: `${day}/${month}/${year}`,
            time: `${hours}:${minutes}`,
        }
    }
    const { date, time } = parseFecha(dateString)
    return (
        <View style={{ flex: 1, marginHorizontal: 3 }}>
            <View style={styles.containerItem}>
                <View style={{ flex: 2 }}>
                    <Text style={styles.position}>+{points}pts</Text>
                </View>

                <View style={{ flex: 4 }}>
                    <Text style={styles.username}>5 Reacciones en muro</Text>
                    {/* <Text style={styles.username}>{activity}</Text> */}
                </View>
                <View style={{ flex: 2 }}>
                    <Text style={[styles.points, { fontSize: 12, textAlign: 'right' }]}>{date}</Text>
                    <Text style={[styles.hr, { fontSize: 12, textAlign: 'right' }]}>{time}</Text>
                </View>
            </View>
            <View style={styles.divider3}></View>
        </View>
    )
}

export const RankingPodium = ({ first_place, second_place, third_place }) => {
    function validateImage(image) {
        if (image == undefined || image == null) return null
        if (image == '') return avatarPlaceholder
        return image
    }
    const isMobile = useIsMobile()
    const [first_place_image, setFirstPlaceImage] = useState(validateImage(first_place.user_avatar))
    const [second_place_image, setSecondPlaceImage] = useState(validateImage(second_place.user_avatar))
    const [third_place_image, setThirdPlaceImage] = useState(validateImage(third_place.user_avatar))
    const isUserInPodium = () => {
        const places = [first_place, second_place, third_place]

        for (const place of places) {
            if (place?.current_user === true) {
                return true
            }
        }

        return false
    }
    const podiumHeight = isMobile ? (isUserInPodium() ? 160 : 120) : isUserInPodium() ? 180 : 132
    const backgroundImage = isMobile
        ? require('../../../assets/trivia/triviaPodiumBackgroundWeb.png')
        : require('../../../assets/trivia/triviaPodiumBackgroundWebLarge.png')
    if (true) {
        return (
            <View
                style={[
                    { backgroundColor: RankingTheme.tabsUnselectedColor, height: podiumHeight, borderRadius: 16, zIndex: 1, width: '100%' },
                    isMobile && { marginHorizontal: 12, width: 'auto' },
                ]}
            >
                <ImageBackground source={backgroundImage} style={{ height: podiumHeight, width: '100%' }} resizeMethod='resize' resizeMode='cover'>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            gap: 28,
                            paddingHorizontal: 12,
                        }}
                    >
                        <View style={{ flexShrink: 1 }}>
                            {second_place && (
                                <PodiumUser
                                    place={2}
                                    full_name={second_place.full_name}
                                    user_avatar={second_place_image}
                                    points={second_place.points}
                                    currentUser={false}
                                />
                            )}
                        </View>
                        <View style={{ flexShrink: 1 }}>
                            {first_place && (
                                <PodiumUser
                                    place={1}
                                    full_name={first_place.full_name}
                                    user_avatar={first_place_image}
                                    points={first_place.points}
                                    currentUser={false}
                                />
                            )}
                        </View>
                        <View style={{ flexShrink: 1 }}>
                            {third_place && (
                                <PodiumUser
                                    place={3}
                                    full_name={third_place.full_name}
                                    user_avatar={third_place_image}
                                    points={third_place.points}
                                    currentUser={false}
                                />
                            )}
                        </View>
                    </View>
                </ImageBackground>
            </View>
        )
    }
}

export function setPodiumUser(user) {
    const emptyRanking = { full_name: '-----', user_avatar: null, points: null, current_user: false }
    return user
        ? {
              full_name: user.name + (user.last_name ? ' ' + user.last_name : ''),
              user_avatar: user.avatar,
              points: user.points,
              current_user: user.current_user,
          }
        : emptyRanking
}

export const NoRankingModal = () => {
    return (
        <View
            style={[
                {
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                { marginHorizontal: 15 },
            ]}
        >
            <Image style={{ width: 132, height: 132 }} source={require('../../../assets/no_podium.png')} />
            <Text
                style={{
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: theme.colors.textPrimary,
                    textAlign: 'center',
                    marginBottom: 8,
                    marginTop: 20,
                }}
            >
                {'El ranking se está preparando'}
            </Text>
            <Text
                style={{
                    fontSize: 15,
                    color: theme.colors.textSecondary,
                    textAlign: 'center',
                    lineHeight: 23,
                }}
            >
                {'Estamos esperando que todos elijan su alias para arrancar. ¡Pronto vas a poder ver quién lidera!'}
            </Text>
        </View>
    )
}

export const PodiumUser = ({ place, full_name, user_avatar, points = null, currentUser = false }) => {
    const PodiumImage = () => {
        switch (place) {
            case 1:
                return <PlaceImage place={1} />
            case 2:
                return <PlaceImage place={2} />
            case 3:
                return <PlaceImage place={3} />
            default:
                return null
        }
    }
    const isMobile = useIsMobile()
    return (
        <View style={{ width: 100, alignSelf: 'center', alignItems: 'center' }}>
            {typeof currentUser === 'boolean' && currentUser === true && (
                <Text style={{ fontWeight: 'bold', color: RankingMainColor, marginBottom: 9, fontSize: 14 }} numberOfLines={1}>
                    {currentUser ? '¡Estas aquí!' : ' '}
                </Text>
            )}

            {user_avatar != null ? (
                <Image
                    source={{ uri: user_avatar }}
                    style={[styles.podium_avatar, { width: 60, height: 60, borderRadius: 30 }]}
                    resizeMethod='resize'
                    resizeMode='contain'
                />
            ) : (
                <PodiumImage />
            )}
            <Text
                style={{ fontWeight: 'bold', color: theme.colors.textPrimary, marginTop: 5, fontSize: 13, textAlign: 'center' }}
                ellipsizeMode='tail'
                numberOfLines={isMobile ? 1 : 2}
            >
                {full_name}
            </Text>
            {points && (
                <View
                    style={[
                        {
                            zIndex: 5,
                            width: 90,
                            height: 25,
                            borderRadius: 10,
                            backgroundColor: 'white',
                            marginTop: 8,
                            justifyContent: 'center',
                            alignItems: 'center',
                        },
                        currentUser === true && {
                            borderColor: theme.colors.colorSecondary,
                            borderWidth: 2,
                            overflow: 'hidden',
                        },
                    ]}
                >
                    <Text
                        style={{
                            color: theme.colors.RankingPointsColor,
                            fontSize: 15,
                            fontWeight: '800',
                            textAlign: 'center',
                            lineHeight: 20,
                        }}
                    >
                        {points}
                        <Text style={{ color: theme.colors.RankingPointsColor, fontSize: 15, fontWeight: '400', lineHeight: 20 }}>pts</Text>
                    </Text>
                </View>
            )}
        </View>
    )
}

const PlaceImage = ({ place }) => {
    const isMobile = useIsMobile()
    return (
        <Text
            style={{
                zIndex: 2,
                color: 'white',
                fontSize: !isMobile ? 36 : 19,
                fontWeight: '800',
                width: !isMobile ? 52 : 40,
                height: !isMobile ? 52 : 40,
                borderRadius: 26,
                overflow: 'hidden',
                lineHeight: !isMobile ? 52 : 40,
                alignSelf: 'center',
                backgroundColor: theme.colors.colorPrimary,
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                marginTop: 3,
                marginRight: 3,
            }}
        >
            {place}
        </Text>
    )
}
